module.exports = __webpack_public_path__ + "static/affiliate/affiliate-insurance-7a5f9dace36e804b55d7804c156a853f.jpg";